import { createContext } from 'react';
export default /*#__PURE__*/createContext({
  register: props => Promise.resolve(props)
});